import React from 'react';
import { useIntl } from 'react-intl';
import ManageNotificationsForm from '../../../components/siteadmin/ManageNotificationsForm/ManageNotificationsForm';
import messages from '../../../locale/jsonMessages';
import { useSelector } from 'react-redux';

const ManageNotifications = () => {
  const { formatMessage } = useIntl();
  const siteName = useSelector((state) => state.siteSettings.data.siteName);

      let initialValues = {
      to: "all",
      messageType: "pushNotification",
      title: siteName
    };

  return (
    <div>
      <h1 className='siteAdminHeading'>{formatMessage(messages.manageNotifications)}</h1>
      <ManageNotificationsForm initialValues={initialValues}/>
    </div>
  )

}

export default ManageNotifications;
